export default [
  {
    component: 'CNavTitle',
    name: 'Visão Geral',
  },
  {
    component: 'CNavItem',
    name: 'Dashboard Principal',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    component: 'CNavTitle',
    name: 'Gestão & Relatórios',
  },
  {
    component: 'CNavGroup',
    name: 'Usuários & Relatórios',
    icon: 'cil-people',
    items: [
      {
        component: 'CNavItem',
        name: 'Usuários das Bancas',
        icon: 'cil-user',
        to: '/UsuariosBanca',
      },
      {
        component: 'CNavItem',
        name: 'Transferência de Usuários',
        icon: 'cil-swap-horizontal',
        to: '/transferencia-usuarios',
      },
      {
        component: 'CNavItem',
        name: 'Relatório Financeiro',
        icon: 'cil-chart-pie',
        to: '/RelatorioFinanceiroUsuario',
      },
      {
        component: 'CNavItem',
        name: 'Fluxo de Caixa',
        icon: 'cil-dollar',
        to: '/RelatorioFinanceiro',
      },
      {
        component: 'CNavItem',
        name: 'Vendas Semanais',
        icon: 'cil-chart-line',
        to: '/RelatorioVendasSemanais',
      },
      {
        component: 'CNavItem',
        name: 'Análise de Faturamento',
        icon: 'cil-chart-line',
        to: '/Faturamento',
      },
      {
        component: 'CNavItem',
        name: 'Metas e Vendas',
        icon: 'cil-chart-line',
        to: '/MetasVendas',
      },
      {
        component: 'CNavItem',
        name: 'Consultores (exportação)',
        icon: 'cil-people',
        to: '/ConsultoresExport',
      },
      {
        component: 'CNavItem',
        name: 'Depósitos Semanais',
        icon: 'cil-wallet',
        to: '/RelatorioDepositosSemanais',
      },
      {
        component: 'CNavItem',
        name: 'Comparativo Semanal',
        icon: 'cil-balance-scale',
        to: '/RelatorioComparativoSemanal',
      },
      {
        component: 'CNavItem',
        name: 'LTV Geral',
        icon: 'cil-chart-line',
        to: '/ltvgeral',
      },
      {
        component: 'CNavItem',
        name: 'Todos | Venda Rápida',
        icon: 'cil-browser',
        to: '/VendaRapidaReport',
      },
      {
        component: 'CNavItem',
        name: 'LTV Cohort',
        icon: 'cil-chart-pie',
        to: '/ltvnew',
      },
      {
        component: 'CNavItem',
        name: 'Relatório Consultores',
        icon: 'cil-briefcase',
        to: '/RelatorioConsultores',
      },
      {
        component: 'CNavItem',
        name: 'Entrega Plano de Carreira',
        icon: 'cil-gift',
        to: '/EntregaPlanoCarreira',
      },
      {
        component: 'CNavItem',
        name: 'Compradores de Combo',
        icon: 'cil-basket',
        to: '/ComboBuyersReport',
      },
      {
        component: 'CNavItem',
        name: 'Venda Rápida',
        icon: 'cil-basket',
        to: '/VendaRapidaReport',
      },
      {
        component: 'CNavItem',
        name: 'Bloquear Consultores',
        icon: 'cil-ban',
        to: '/Consultores',
      },
      {
        component: 'CNavItem',
        name: 'Alterar ID do Consultor',
        icon: 'cil-pencil',
        to: '/ChangeConsultID',
      },
      {
        component: 'CNavItem',
        name: 'Limites de Saque / Nível',
        icon: 'cil-equalizer',
        to: '/ValoresSaqueNiveis',
      },
      {
        component: 'CNavItem',
        name: 'Todos | Gerenciar Lives',
        icon: 'cil-video',
        to: '/gerenciar-lives',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Financeiro & Saques',
    icon: 'cil-dollar',
    items: [
      {
        component: 'CNavItem',
        name: 'Solicitações de Saques',
        icon: 'cil-wallet',
        to: '/Saques',
      },
      {
        component: 'CNavItem',
        name: 'Gateway de Saques',
        icon: 'cil-credit-card',
        to: '/gateways-saque',
      },
      {
        component: 'CNavItem',
        name: 'Saldo de Usuários',
        icon: 'cil-dollar',
        to: '/UsuariosSaldo',
      },
      {
        component: 'CNavItem',
        name: 'Auditoria de Combos',
        icon: 'cil-shield-alt',
        to: '/auditoria-combos',
      },
    ],
  },
  {
    component: 'CNavTitle',
    name: 'Operacional & Jogos',
  },
  {
    component: 'CNavGroup',
    name: 'Gestão de Loterias',
    icon: 'cil-star',
    items: [
      {
        component: 'CNavItem',
        name: 'Novo Concurso',
        icon: 'cil-notes',
        to: '/CriarConcurso',
      },
      {
        component: 'CNavItem',
        name: 'Gerenciar Concursos',
        icon: 'cil-task',
        to: '/ExcluirConcurso',
      },
      {
        component: 'CNavItem',
        name: 'Agendar Concursos',
        icon: 'cil-calendar',
        to: '/AgendarConcurso',
      },
      {
        component: 'CNavItem',
        name: 'Enviar Resultados',
        icon: 'cil-check',
        to: '/EnviarResultado',
      },
      {
        component: 'CNavItem',
        name: 'Aprovação Prêmio Loteria',
        icon: 'cil-check-circle',
        to: '/AprovarPremio',
      },
      {
        component: 'CNavItem',
        name: 'Aprovação Automática Loteria',
        icon: 'cil-sync',
        to: '/AprovacaoAutomatica',
      },
      {
        component: 'CNavItem',
        name: 'Lista de Ganhadores',
        icon: 'cil-list',
        to: '/modulo3',
      },
      {
        component: 'CNavItem',
        name: 'Sobrepor Resultados',
        icon: 'cil-layers',
        to: '/Modulo4',
      },
      {
        component: 'CNavItem',
        name: 'Conferência de Bilhetes',
        icon: 'cil-magnifying-glass',
        to: '/PegaLadrao',
      },
      {
        component: 'CNavItem',
        name: 'Bilhetes Premiados',
        icon: 'cil-swap-horizontal',
        to: '/trocanumero',
      },
      {
        component: 'CNavItem',
        name: 'Análise de Dezenas',
        icon: 'cil-chart-pie',
        to: '/AnaliseDezenas',
      },
      {
        component: 'CNavItem',
        name: 'Comissões Dezenas',
        icon: 'cil-calculator',
        to: '/ComissoesDezenas',
      },
      {
        component: 'CNavItem',
        name: 'Log de Bilhetes',
        icon: 'cil-notes',
        to: '/LogBancasPremios',
      },
      {
        component: 'CNavItem',
        name: 'Backup Ganhadores Escritório',
        icon: 'cil-cloud-download',
        to: '/ListaGanhadoresEscritorio',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Módulo Bichão',
    icon: 'cil-grid',
    items: [
      {
        component: 'CNavItem',
        name: 'Lista de Ganhadores Bichão',
        icon: 'cil-list',
        to: '/GanhadoresBichao',
      },
      {
        component: 'CNavItem',
        name: 'Aprovar Premiações Bichão',
        icon: 'cil-check-circle',
        to: '/AprovarPremioBichao',
      },
      {
        component: 'CNavItem',
        name: 'Aprovação Automática Bichão',
        icon: 'cil-sync',
        to: '/AprovacaoAutomaticaBichao',
      },
      {
        component: 'CNavItem',
        name: 'Descarrego Bichão',
        icon: 'cil-envelope-open',
        to: '/descarrego',
      },
      {
        component: 'CNavItem',
        name: 'Descarrego Loterias',
        icon: 'cil-envelope-open',
        to: '/descarregoloterias',
      },
      {
        component: 'CNavItem',
        name: 'Descarrego por Banca',
        icon: 'cil-envelope-open',
        to: '/descarregobanca',
      },
    ],
  },
  {
    component: 'CNavTitle',
    name: 'Marketing & Comunicação',
  },
  {
    component: 'CNavGroup',
    name: 'Marketing & Campanhas',
    icon: 'cil-bullhorn',
    items: [
      {
        component: 'CNavItem',
        name: 'Links Ads',
        icon: 'cil-code',
        to: '/LinksAdsNew',
      },
      {
        component: 'CNavItem',
        name: 'Facebook Ads',
        icon: 'cil-globe-alt',
        to: '/FacebookAds',
      },
      {
        component: 'CNavItem',
        name: 'Notificações WhatsApp',
        icon: 'cil-speech',
        to: '/WhatsappNotification',
      },
      {
        component: 'CNavItem',
        name: 'Monitor Campanhas WhatsApp',
        icon: 'cil-speech',
        to: '/WhatsappCampaignMonitor',
      },
      {
        component: 'CNavItem',
        name: 'Popups Informativos',
        icon: 'cil-comment-square',
        to: '/Popups',
      },
      {
        component: 'CNavItem',
        name: 'Barras de Aviso',
        icon: 'cil-layers',
        to: '/newbarrar',
      },
      {
        component: 'CNavItem',
        name: 'Sua Rifa',
        icon: 'cil-gift',
        to: '/rifa',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Customizações & Layout',
    icon: 'cil-puzzle',
    items: [
      {
        component: 'CNavItem',
        name: 'Banners Principais',
        icon: 'cil-layers',
        to: '/Banners',
      },
      {
        component: 'CNavItem',
        name: 'Roleta Promocional',
        icon: 'cil-star',
        to: '/Roleta',
      },
      {
        component: 'CNavItem',
        name: 'Caixinha Surpresa',
        icon: 'cil-star',
        to: '/CaixinhaSurpresa',
      },
      {
        component: 'CNavItem',
        name: 'Ícones da Sidebar',
        icon: 'cil-options',
        to: '/layput/sidebar',
      },
      {
        component: 'CNavItem',
        name: 'Cres do Site',
        icon: 'cil-drop',
        to: '/layput/corsite',
      },
      {
        component: 'CNavItem',
        name: 'Botões do Site',
        icon: 'cil-cursor',
        to: '/layput/btnsite',
      },
      {
        component: 'CNavItem',
        name: 'Botões da Home',
        icon: 'cil-cursor',
        to: '/layput/btnhome',
      },
      {
        component: 'CNavItem',
        name: 'Tipos de Jogo',
        icon: 'cil-settings',
        to: '/tipodejogo',
      },
    ],
  },
  {
    component: 'CNavTitle',
    name: 'Sistema & Logs',
  },
  {
    component: 'CNavGroup',
    name: 'Logs Centralizados',
    icon: 'cil-shield-alt',
    items: [
      {
        component: 'CNavItem',
        name: 'Bancas & API Keys',
        icon: 'cil-lock-locked',
        to: '/central-logs/bancas',
      },
      {
        component: 'CNavItem',
        name: 'Alertas Críticos',
        icon: 'cil-bell',
        to: '/central-logs/regras',
      },
      {
        component: 'CNavItem',
        name: 'Visualizar Logs',
        icon: 'cil-list',
        to: '/central-logs',
      },
    ],
  },
  {
    component: 'CNavItem',
    name: 'Gestão de Usuários',
    to: '/usuarios',
    icon: 'cil-user',
  },
  {
    component: 'CNavItem',
    name: 'Configurações Globais',
    icon: 'cil-settings',
    to: '/config',
  },
  {
    component: 'CNavItem',
    name: 'Meu Perfil',
    icon: 'cil-user',
    to: '/perfil',
  },
  {
    component: 'CNavItem',
    name: 'Logs do Sistema',
    to: '/logs',
    icon: 'cil-warning',
  },
]
